export class TutelaProvisoria{
    public Id: number;
    public ProcessoId: number;
    public ClienteId: number;
    public ClienteNome: string;
    public UnidadeId: number;
    public NumeroParcelas: number;
    public ValorPrimeiraParcela: number;
    public VencimentoInicial: string;

    public PercentualEscritorio: number;
    public TipoDREscritorio: number;
    public Advogados: TutelaProvisoriaAdvogado[];

    public SubstabelecidoId: number;
    public TipoDRSubstabelecido: number;
    public PercentualSubstabelecido: number;

    public EncaminhadoPorId: number;
    public TipoDREncaminhadoPor: number;
    public PercentualEncaminhadoPor: number;

    public ValorMensal: number;
    public Descricao: string;
    public Observacao: string;
    public Encerrado: boolean;

    constructor(){
        this.ValorMensal = 0;
        this.NumeroParcelas = 1;
        this.ValorPrimeiraParcela = 0.0;
        this.PercentualEscritorio = 0;
        this.PercentualEncaminhadoPor = 0;
        this.PercentualSubstabelecido = 0;
        this.TipoDREscritorio = null;
        this.TipoDREncaminhadoPor = null;
        this.TipoDRSubstabelecido = null;
        this.Advogados = [];
    }
}

export class TutelaProvisoriaAdvogado{
    public Id: number;
    public TutelaProvisoriaId: number;
    public AdvogadoId: number;
    public TipoDR: number;
    public Percentual: number;
    public UnidadeId: number;
    public Desbloqueado: boolean;

    constructor() {
        this.Id = 0;
        this.TipoDR = null;
        this.Percentual = 0;
        this.Desbloqueado = true;
    }
}